<template>
    <DsModalDialog v-model="isOpened">
        <template #content>
            <img :src="image" :alt="alt" :class="{ rotated: isRotated }" />
        </template>
    </DsModalDialog>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from "vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";

const props = defineProps<{
    trigger: string;
    image: string;
    alt: string;
    rotated: string;
}>();

const isOpened = ref<boolean>(false);

const isRotated = computed(() => !!props.rotated);

onMounted(() => {
    // Bind open triggers
    const trigger = document.querySelector(`.js-tim-trigger#${props.trigger}`);
    if (!trigger) return;

    trigger.addEventListener("click", (e) => {
        e.preventDefault();

        isOpened.value = true;
    });
});
</script>
